import { render } from "./LabelListWidget.vue?vue&type=template&id=2d383aa2&ts=true"
import script from "./LabelListWidget.ts?vue&type=script&lang=ts&external"
export * from "./LabelListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__